import certificationSampleImage from '@/assets/images/about/certification/certification-sample.webp';
import type { AdminCertificationAssetDetail } from '@/features/content/types';

interface CertificationSeedInput {
  id: number;
  category: AdminCertificationAssetDetail['category'];
  title: string;
  displayOrder: number;
  acquiredYear: number;
  publishedAt: string;
  isPublished?: boolean;
}

const certificationSeedEntries: CertificationSeedInput[] = [
  {
    id: 1,
    category: 'patent-design',
    title: 'CO₂ 로고 라벨',
    displayOrder: 0,
    acquiredYear: 2015,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 2,
    category: 'patent-design',
    title: 'CI-K 라벨',
    displayOrder: 1,
    acquiredYear: 2015,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 3,
    category: 'patent-design',
    title: '냉동창고 작업자 안전관리장치 및 안전관리시스템',
    displayOrder: 2,
    acquiredYear: 2024,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 4,
    category: 'patent-design',
    title: '쇼케이스용 라벨홀더',
    displayOrder: 3,
    acquiredYear: 2015,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 5,
    category: 'patent-design',
    title: '에너지절감 라벨',
    displayOrder: 4,
    acquiredYear: 2015,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 6,
    category: 'patent-design',
    title: '배수관 드레인용 슬러지 처리기',
    displayOrder: 5,
    acquiredYear: 2015,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 7,
    category: 'patent-design',
    title: '쇼케이스형 와인 냉장고',
    displayOrder: 6,
    acquiredYear: 2022,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 8,
    category: 'patent-design',
    title: '복합 냉각장치 및 필터 세정방법',
    displayOrder: 7,
    acquiredYear: 2021,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 9,
    category: 'patent-design',
    title: '콤프레샤 렌치',
    displayOrder: 8,
    acquiredYear: 2015,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 10,
    category: 'certification',
    title: '유망중소기업 인증서',
    displayOrder: 0,
    acquiredYear: 2023,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 11,
    category: 'certification',
    title: '기술역량 우수기업 인증서',
    displayOrder: 1,
    acquiredYear: 2024,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 12,
    category: 'certification',
    title: '기업부설연구소 인정서',
    displayOrder: 2,
    acquiredYear: 2017,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 13,
    category: 'certification',
    title: '한국품질우수기업선정',
    displayOrder: 3,
    acquiredYear: 2017,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 14,
    category: 'certification',
    title: '클린경영인증서',
    displayOrder: 4,
    acquiredYear: 2014,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 15,
    category: 'certification',
    title: 'INNO-BIZ 확인서',
    displayOrder: 5,
    acquiredYear: 2021,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 16,
    category: 'certification',
    title: '벤처기업확인서',
    displayOrder: 6,
    acquiredYear: 2020,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 17,
    category: 'certification',
    title: '구리시 표창장',
    displayOrder: 7,
    acquiredYear: 2017,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 18,
    category: 'certification',
    title: '건설업등록증(실내건축)',
    displayOrder: 8,
    acquiredYear: 2025,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 19,
    category: 'certification',
    title: '건설업등록증(기계설비)',
    displayOrder: 9,
    acquiredYear: 2012,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 20,
    category: 'certification',
    title: '제 1공장 등록 증명서',
    displayOrder: 10,
    acquiredYear: 2024,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 21,
    category: 'certification',
    title: '제 2공장 등록 증명서',
    displayOrder: 11,
    acquiredYear: 2025,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 22,
    category: 'certification',
    title: '국립전파연구원 적합등록',
    displayOrder: 12,
    acquiredYear: 2019,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 23,
    category: 'certification',
    title: '냉매회수업 등록증',
    displayOrder: 13,
    acquiredYear: 2019,
    publishedAt: '2026-04-16T00:00:00',
  },
  {
    id: 24,
    category: 'certification',
    title: '인재육성형 중소기업 지정서',
    displayOrder: 14,
    acquiredYear: 2021,
    publishedAt: '2026-04-16T00:00:00',
  },
];

export const createInitialMockCertificationAssets = (): AdminCertificationAssetDetail[] => {
  return certificationSeedEntries.map((entry) => ({
    id: entry.id,
    category: entry.category,
    title: entry.title,
    acquiredYear: entry.acquiredYear,
    imageUrl: certificationSampleImage,
    imageFileName: 'certification-sample.png',
    imageContentType: 'image/png',
    imageFileSize: 102_647,
    imageFit: 'contain',
    imageObjectPosition: 'center center',
    imageScale: 1,
    displayOrder: entry.displayOrder,
    isPublished: entry.isPublished ?? true,
    publishedAt: entry.publishedAt,
  }));
};
